<template>
  <div class="rate">
    <el-dialog v-if="dialogVisible" title="新注册代理默认分佣比例" :visible.sync="dialogVisible" width="540px" modal-append-to-body
               append-to-body>
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="新注册代理默认分佣比例" prop="commissionRate">
          <el-input v-model="form.commissionRate" placeholder="输入范围：0~8">
            <template slot="append">%</template></el-input>
        </el-form-item>
      </el-form>
      <div class="rate-tip">

        <div class="rate-bottom color-pink">
          <div>
            1、新的分销代理通过您分享的链接注册成功后分佣比例将自动设置为此默认分佣比例。
          </div>
          <div>
            2、此处比例修改不影响已注册成功分销代理的分佣比例。
          </div>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="onCancel">取 消</el-button>
        <el-button type="warning" @click="onSure" :loading="saveLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import douYin from "@/javaApi/douyin";
import { matchFractionalPart1 } from "@/utils/regExp";
const DouYinModel = new douYin();
export default {
  props: {
    row: {
      // 行数据
      type: Object,
      default: () => { },
    },
    isBatch: {
      // 是否是批量操作
      type: Boolean,
      default: false,
    },
    ids: {
      // ids的集合
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        commissionRate: ''
      },
      saveLoading: false, // 保存按钮
      dialogVisible: false, // 显示弹框
      rules: {
        commissionRate: [
          {
            required: true,
            message: "请输入佣金比例 ",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            pattern: matchFractionalPart1,
            message: "请输入数字，最多保留一位小数 ",
            trigger: ["blur", "change"],
          },
          {
            required: true,
            validator: (rule, value, callback) => {
              if (value > 8) {
                callback(new Error("请输入小于8的佣金比例"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  methods: {
    // 打开弹框
    onOpenDialog() {
      this.dialogVisible = true;
    },
    // 批量操作
    onBatch() {
      if (this.ids && this.ids.length) {
        this.dialogVisible = true;
      } else {
        this.$message.error("请先选择达人");
      }
    },
    // 取消
    onCancel() {
      this.$refs.form.resetFields();
      this.dialogVisible = false;
    },
    // 确定
    onSure() {
      this.saveLoading = true;
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const data = await DouYinModel.setDefaultAgentRateKs({
            ...this.form,
          }).finally(() => {
            this.saveLoading = false;
          });
          if (data.data.code === 200) {
            this.onCancel();
            this.$emit("getInfo");
            this.$message.success(data.data.message);
          } else {
            this.$message.error(data.data.message);
          }
        } else {
          this.saveLoading = false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.el-form {
  margin-top: 20px;

  .el-input {
    width: 213px;
  }

}

.rate {
  &-tip {
    background: #FAFAFA;
    padding: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kuaishou/proxyList/SetDefaultCommissionRate.vue